var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({ref:"editable",class:{ 'content-editable': _vm.editable },attrs:{"contenteditable":_vm.editable,"placeholder":"Entrer un texte"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;$event.preventDefault();}}},_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }